export default __webpack_public_path__ + "static/media/upcomingIcon.bd21be2f.svg";